import { StylesConfig } from "react-select";

import { PopoutOption } from "./index";

/**
 * returns custom styles object for react-select
 * @param showSearch shows or hides the control component
 * @returns
 */
export const getCustomStyles = (showSearch: boolean): StylesConfig<PopoutOption, false> => ({
	control: (provided) => ({
		...provided,
		flexDirection: "row-reverse",
		minWidth: "162px",
		minHeight: "32px",
		maxHeight: "32px",
		borderRadius: "4px",
		margin: "4px",
		border: "1px solid var(--py-neutral-3)",
		boxShadow: "none",
		":hover": {
			borderColor: "var(--py-primary-5)",
		},
		"::after": {
			content: "''",
			position: "absolute",
			top: "0px",
			right: "0px",
			bottom: "0px",
			left: "0px",
			borderRadius: "4px 4px 0 0",
			border: "1px solid var(--py-neutral-3)",
			borderBottom: "none",
			margin: "-5px",
		},
		// removes search component entirely
		...(showSearch ? {} : { display: "none" }),
	}),
	menu: (provided) => ({
		...provided,
		...(showSearch ? { borderRadius: "0 0 4px 4px" } : { borderRadius: "4px" }),
		marginTop: "0px",
		boxShadow: "0px",
		border: "1px solid var(--py-neutral-3)",
		// keeps manu same width as the control
		minWidth: "166px",
		overflow: "hidden",
		// target child div of styled menu to remove extra padding and set max height
		"> div": {
			maxHeight: "198px",
			paddingTop: "0px",
			paddingBottom: "0px",
		},
	}),
});
